import React from 'react';

export default function FilterBar({
  filters = {},
  setFilters,
  onFilterChange,
  onReset,
  parties = []
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...filters, [name]: value };
    if (setFilters) {
      setFilters(updated);
    }
    if (onFilterChange) {
      onFilterChange(updated);
    }
  };

  return (
    <div className="filter-bar-card">
      {/* Date Range: From – To */}
      <div className="d-flex align-items-center gap-1">
        <input
          type="date"
          name="dateFrom"
          className="filter-input"
          value={filters?.dateFrom || ""}
          onChange={handleChange}
          style={{ width: 130 }}
        />
        <span style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '500' }}>–</span>
        <input
          type="date"
          name="dateTo"
          className="filter-input"
          value={filters?.dateTo || ""}
          onChange={handleChange}
          style={{ width: 130 }}
        />
      </div>

      {/* Party / Ledger Dropdown */}
      <select
        name="partyCode"
        className="filter-select"
        value={filters?.partyCode || ""}
        onChange={handleChange}
        style={{ maxWidth: 200 }}
      >
        <option value="">Party / Ledger: All</option>
        {parties && parties.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>

      {/* Duty Slip Status */}
      <select
        name="dutySlipStatus"
        className="filter-select"
        value={filters?.dutySlipStatus || ""}
        onChange={handleChange}
      >
        <option value="">Duty Slip Status: All</option>
        <option value="Generated">Generated</option>
        <option value="Not Generated">Not Generated</option>
      </select>

      {/* Invoice Status */}
      <select
        name="invoiceStatus"
        className="filter-select"
        value={filters?.invoiceStatus || ""}
        onChange={handleChange}
      >
        <option value="">Invoice Status: All</option>
        <option value="Generated">Generated</option>
        <option value="Not Generated">Not Generated</option>
      </select>

      {/* Reset */}
      <div className="ms-auto d-flex gap-2">
        <button type="button" className="filter-btn-reset" onClick={onReset} title="Reset to current month defaults">
          Reset
        </button>
      </div>
    </div>
  );
}
